import React, { useEffect } from "react";
import ReactDOM from "react-dom";

const SafariModalWrapper = ({ show, onClose, children }) => {
  const [modalContainer] = React.useState(() => document.createElement("div"));

  useEffect(() => {
    document.body.appendChild(modalContainer);
    return () => {
      document.body.removeChild(modalContainer);
    };
  }, [modalContainer]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        pointerEvents: "auto",
      }}
      onClick={onClose} // clicking outside closes modal
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "1.5rem",
          maxHeight: "80vh",
          width: "600px",
          overflowY: "auto",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()} // prevent inner clicks from closing
      >
        {children}
      </div>
    </div>,
    modalContainer
  );
};

export default SafariModalWrapper;
